import { useCallback, useState } from 'react'
import { SortDirection } from '@global/api/types'

export const useSort = () => {
  const [sort, setSort] = useState<SortDirection>(SortDirection.DESC)

  const onSortChange = useCallback(event => {
    const value = event.target.value ?? ''
    setSort(value)
  }, [])

  return { sort, onSortChange }
}
